export default {
    book_now: 'Резервирай сега',
    minimum_age: 'Само за лица на възраст над {age} години',
    excess_liability: 'Отговорност за излишък',
    security_deposit: 'Гаранционна сума',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Като за като',
    full_to_full: 'Пълно до пълно',
    miles_per_rental: '{mileage} безплатни мили на прокат',
    km_per_rental: '{mileage} безплатни километри на прокат',
    unlimited_mileage: 'Неограничен пробег',
    unlimited_mileage_km: 'Неограничени километри',
    non_amendable: 'Не може да се променя',
    non_refundable: 'Не се възстановява',
    free_cancellation_until: 'Безплатно анулиране до',
    cancellation_in_line_with: 'Анулиране в съответствие с',
    tcs: 'Условията и правилата',
    free_extras_on_collection: 'Два безплатни допълнителни елемента при получаване',
    glass_and_tyres_covered: 'Покритие на стъклата и гумите',
    number_of_passengers: 'Брой пътници',
    number_of_bags: 'Брой багаж',
    fuel_type: 'Тип гориво',
    co2: 'CO2',
    aircon: 'Климатик',
    transmission: 'Трансмисия',
    book_type: 'Резервирай {type}',
    debit_card_deposit: 'Приемат се дебитни карти за гаранционна сума',
    fast_track_included: 'Включен бърз път',
}